<div class="bmc-tableau-detail">
  <label class="bmc-tableau-detail__title" *ngIf="isConexion">{{tableauConfiguration.DisplayName}}</label>
  <label class="bmc-tableau-detail__title" *ngIf="!isConexion">{{reportConfiguration.DisplayName}}</label>

  <div class="bmc-tableau-detail__container">
    <div class="bmc-tableau-detail__label" *ngIf="isConexion" [innerHtml]="tableauConfiguration.Description | safeHtml"></div>

    <div *ngIf="isConexion">
      <bzg-input [(ngModel)]="tableauConfiguration.Config.Environment.Params.ClientId" [placeholder]="'TABLEAU.EXAMPLEGUID' | translate" required>
        {{'TABLEAU.CLIENTID' | translate}}
        <bzg-required-error>{{'TABLEAU.FIELD_REQUIRED' | translate}}</bzg-required-error>
      </bzg-input>
      <div *ngIf="showErrorGuid(tableauConfiguration.Config.Environment.Params.ClientId)" class="showError">{{'TABLEAU.INVALID_GUID' | translate}}</div>

      <div class="bmc-tableau-detail__title_secret">{{'TABLEAU.CLIENTSECRET' | translate}} *</div>
      <div class="bz-input-icon">
        <input class="bz-input bz-input-icon__input bz-space--inline-s"
          [(ngModel)]="tableauConfiguration.Config.Environment.Params.ClientSecret" type="{{showEncryptFlagClientSecret ? 'text':'password'}}"
          (blur)="encryptFieldsPassword(0)"
          required>
        <svg class="bz-icn bz-space--inline-s cursor-pointer" (click)="showEncryptClientSecret()"  height="32px" width="32px">
          <use href="#icon-eye" *ngIf="!showEncryptFlagClientSecret"></use>
          <use href="#icon-eye-closed" *ngIf="showEncryptFlagClientSecret"></use>
        </svg>
      </div>
      <div *ngIf="showErrorRequired(tableauConfiguration.Config.Environment.Params.ClientSecret)" class="showError">{{'TABLEAU.FIELD_REQUIRED' | translate}}</div>
      <div *ngIf="passwordEncrypt(tableauConfiguration.Config.Environment.Params.ClientSecret)" class="showError">{{'TABLEAU.INVALID_SECRET' | translate}}</div>

      <div class="bmc-tableau-detail__title_secret">{{'TABLEAU.SECRETVALUE' | translate}} *</div>
      <div class="bz-input-icon">
        <input class="bz-input bz-input-icon__input bz-space--inline-s"
          [(ngModel)]="tableauConfiguration.Config.Environment.Params.SecretValue" type="{{showEncryptFlagSecretValue ? 'text':'password'}}"
          (blur)="encryptFieldsPassword(1)"
          required>
        <svg class="bz-icn bz-space--inline-s cursor-pointer" (click)="showEncryptSecretValue()"  height="32px" width="32px">
          <use href="#icon-eye" *ngIf="!showEncryptFlagSecretValue"></use>
          <use href="#icon-eye-closed" *ngIf="showEncryptFlagSecretValue"></use>
        </svg>
      </div>
      <div *ngIf="showErrorRequired(tableauConfiguration.Config.Environment.Params.SecretValue)" class="showError">{{'TABLEAU.FIELD_REQUIRED' | translate}}</div>
      <div *ngIf="passwordEncrypt(tableauConfiguration.Config.Environment.Params.SecretValue)" class="showError">{{'TABLEAU.INVALID_SECRET' | translate}}</div>

      <div class="bmc-tableau-detail__title_secret">{{'TABLEAU.USER_MODE' | translate}} *</div>
      <bzg-select [placeholder]="'GLOBAL.SELECT_ONE'|translate" [value]="userModeSelected" style="width: 100%;" (valueChange)="selectUserMode($event)">
        <bzg-option [value]="'Email'">{{'TABLEAU.EMAIL' | translate}}</bzg-option>
        <bzg-option [value]="'LoggedInApps'">{{'TABLEAU.LOGGED_IN_APPS' | translate}}</bzg-option>
      </bzg-select>

      <div *ngIf="userModeSelected && userModeSelected == 'Email'">
        <bzg-input name="basicBccOauth" [(ngModel)]="tableauConfiguration.Config.Environment.Params.UserEmail" [maxlength]="4000"
          [placeholder]="'TABLEAU.EMAIL_EX' | translate" type="email">
          {{'TABLEAU.EMAIL' | translate}}
        </bzg-input>
        <div *ngIf="validateMail()" class="showError">{{errorMail}}</div>        
      </div>
    </div>
    <div *ngIf="!isConexion">
      <bzg-input [(ngModel)]="reportConfiguration.Config.Environment.Params.Url" [placeholder]="'TABLEAU.EXAMPLEURL' | translate" required>
        {{'TABLEAU.URL' | translate}}
        <bzg-required-error>{{'TABLEAU.FIELD_REQUIRED' | translate}}</bzg-required-error>
      </bzg-input>      
    </div>

    <div class="bmc-tableau-detail__apply-button">
      <bzg-button-primary type="button" (click)="updateData()" [disabled]="btnDisabled()">
        {{ "GLOBAL.APPLY" | translate }}
      </bzg-button-primary>
    </div>
  </div>
</div>
